export const playersState = {
  state: {
    videosArray: [],
    currentVideoIndex: 0,
    shouldReplayVideo: false,
    previousPlayerVolume: 1,
    playerInBodyNumber: 0,
  },
  setState(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      this.state[key] = value;
    }
  },
  getState(key) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      return this.state[key];
    }
    return undefined;
  },
};
